/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import { ReactComponent as ShoppingBagIcon } from 'assets/icons/shopping-bag.svg';

import CartIcon from 'Component/CartIcon';
import Link from 'Component/Link';
import { NavigationTabs as SourceNavigationTabs } from 'SourceComponent/NavigationTabs/NavigationTabs.component';

import { MY_OFFERS_URL } from './NavigationTabs.config';

/** @namespace Pwa/Component/NavigationTabs/Component */
export class NavigationTabs extends SourceNavigationTabs {
    renderMinicartItemsQty() {
        const { cartTotals: { items_qty, items } } = this.props;

        if (!items_qty) {
            return null;
        }

        return (
            <span
              aria-label={ __('Items in offer') }
              block="Header"
              elem="MinicartItemCount"
            >
                { items?.length }
            </span>
        );
    }

    renderOfferLink() {
        const { activeOfferId } = this.props;

        const link = activeOfferId ? `/offers/${activeOfferId}` : MY_OFFERS_URL;

        return (
            <Link
              to={ link }
              key="offer"
              block="NavigationTabs"
              elem="Button"
            >
                <div>
                    <ShoppingBagIcon />
                    { this.renderOfferItemsQty() }
                </div>
            </Link>
        );
    }

    renderOfferItemsQty() {
        const { device: { isMobile }, offerItemsCount } = this.props;

        if (!offerItemsCount) {
            return null;
        }

        return (
            <span
              aria-label="Items in cart"
              block="Header"
              elem="OfferItemCount"
              mods={ { isMobile } }
            >
                { offerItemsCount }
            </span>
        );
    }

    renderMinicartButton(isActive = false) {
        const { onMinicartButtonClick } = this.props;

        return (
            <>
                { this.renderOfferLink() }
                <button
                  key="mincart"
                  block="NavigationTabs"
                  elem="Button"
                  onClick={ onMinicartButtonClick }
                  aria-label="Minicart"
                >
                    <div block="Header" elem="MinicartWrapper">
                        <div
                          block="Header"
                          elem="Button"
                          mix={ { block: 'NavigationTabs', elem: 'Icon', mods: { isActive } } }
                          mods={ { isVisible: true, type: 'minicart' } }
                        >
                            <CartIcon isActive={ isActive } />
                        </div>
                        { this.renderMinicartItemsQty() }
                    </div>
                </button>
            </>
        );
    }
}

export default NavigationTabs;
